<template>
    <div>
        <!-- Modal Criar Etiqueta -->
        <div class="modal fade" :id="modal_name" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog modal-lg modal-dialog-scrollable" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Gerar Etiqueta</h5>
                        <button type="button" class="close" @click="fechar_modal()" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body" v-if="edicao_atp_etq">
                        <div class="form-row">
                            <div class="col col-12" :class="edicao_atp_etq.tipo && edicao_atp_etq.tipo.id_sinalizador_atendimento ? 'col-md-6' : ''">
                                <az-input
                                    type="select"
                                    label="Tipo de Etiqueta"
                                    optionsMode="aql"
                                    service="tipo_etiqueta_amostras.index"
                                    optionsData2="id_tipo_etiqueta_amostra"
                                    optionsName="tipo_etiqueta_amostras.index.gerar"
                                    :optionsParm="{ ativos: true, geracao: true }"
                                    required
                                    :validate="validate"
                                    v-model="edicao_atp_etq.tipo" />
                            </div>

                            <div class="col col-12 col-md-6" v-if="edicao_atp_etq.tipo && edicao_atp_etq.tipo.id_sinalizador_atendimento">
                                <az-input
                                    label="Observação"
                                    v-model="edicao_atp_etq.sinal_obs" />
                            </div>
                        </div>

                        <template v-if="edicao_atp_etq.tipo">

                            <div class="form-row mt-3" v-if="edicao_atp_etq.tipo && edicao_atp_etq.tipo.fl_selec_cassete">
                                <div class="col col-12" :class="opcoes ? 'col-md-6' : ''">
                                    <div class="d-flex justify-content-between">
                                        <a href="#" @click.prevent="marcar_cassete_todos()" class="small card-link">Cassetes</a>
                                        <div>
                                            <span class="badge badge-secondary">{{ cassetes_selecionados.length }}</span>
                                        </div>
                                    </div>
                                    <div class="list-group" v-if="lista_cassetes && lista_cassetes.length">
                                        <button type="button" 
                                            class="list-group-item list-group-item-action" 
                                            :class="cassete.fl_ativo ? '' : 'active'" 
                                            @click="cassete.fl_ativo = !cassete.fl_ativo" 
                                            v-for="(cassete, iox) in lista_cassetes" :key="iox">
                                            <strong>{{ cassete.st_titulo }}</strong>
                                            <span class="ml-2">{{ cassete.st_codigo }}</span>
                                            <span class="small text-muted ml-2" v-if="cassete.st_destino">{{ cassete.st_destino }}</span>
                                        </button>
                                    </div>

                                    <az-input
                                        v-if="false"
                                        type="select"
                                        label="Cassete"
                                        :optionsList="lista_cassetes"
                                        optionsData="id_amostra"
                                        required
                                        :validate="validate"
                                        v-model="edicao_atp_etq.id_amostra_origem" />
                                </div>

                                <div class="col col-12 col-md-6" v-if="opcoes && opcoes.length">
                                    <div class="d-flex justify-content-between">
                                        <label class="small text-muted">Opções</label>
                                        <div>
                                            <span class="badge badge-secondary">{{ opcoes_selecionadas.length }}</span>
                                        </div>
                                    </div>
                                    <ul class="list-group">
                                        <li class="list-group-item d-flex justify-content-between align-items-center" :class="opcao.selec ? 'active' : ''" v-for="(opcao, iox) in opcoes" :key="iox">
                                            <a href="#" class="card-link" :class="opcao.selec ? 'text-white' : ''" @click.prevent="opcao.selec = !opcao.selec" v-if="!opcao.edit">
                                                {{ opcao.nome }}
                                            </a>
                                            <az-input
                                                v-else
                                                type="text"
                                                sizing="sm"
                                                v-model="opcao.nome" />

                                            <a href="#" @click.prevent="opcao.edit = !opcao.edit" v-if="!opcao.selec">
                                                <i class="fas fa-pen" v-if="!opcao.edit"></i>
                                                <i class="fa fa-check text-success" aria-hidden="true" v-else></i>
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                            </div>

                            <template v-else>

                                <div class="form-row mb-2">
                                    <div class="col col-12 col-md-6" v-if="!tem_opcoes">
                                        <az-input
                                            type="number"
                                            label="Quantidade"
                                            required
                                            :validate="validate"
                                            v-model="edicao_atp_etq.in_quantidade" 
                                            @input="refresh_lista"/>
                                    </div>
                                </div>

                                <div class="form-row" v-for="(item_novo, iix) in lista_nova" :key="iix">
                                    <div class="col col-12">
                                        <az-input
                                            type="text"
                                            sizing="sm"
                                            placeholder="Padrão..."
                                            :compact="true"
                                            :label="(iix + 1).toString()"
                                            v-model="item_novo.st_titulo" />
                                    </div>
                                </div>

                            </template>

                        </template>

                        <pre v-if="false">{{ lista_cassetes }}</pre>
                    </div>
                    <div class="modal-footer d-flex justify-content-between">
                        <div>
                            <template v-if="servidor_impressao">
                                <az-input   
                                    sizing="sm"
                                    type="checkbox-group"
                                    label="Imprimir Etiquetas Geradas"
                                    v-model="impressao_ao_gerar" />
                                <div class="small text-muted">{{ servidor_impressao }}</div>
                            </template>
                        </div>
                        <div>
                            <button type="button" class="btn btn-secondary mr-1" @click="fechar_modal()">Cancelar</button>
                            <az-submit @click="salvar_gerar_etiqueta()">Gerar</az-submit>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import _ from 'lodash';
import $ from 'jquery';
import AzInput from '../../shared/forms/AzInput.vue';
import AzSubmit from '../../util/AzSubmit.vue';

export default {
    data() {
        return {
            atp: null, 
            edicao_atp_etq: null,
            validate: false, 
            opcoes: [], 
            modal_name: "", 
            lista_cassetes: [], 
            lista_nova: [],
            impressao_ao_gerar: true, 
            servidor_impressao: "", 
        }
    },

    components: {
        AzInput,
        AzSubmit,
    },

    props: ['amostras'], 

    computed: { 
        tem_opcoes: function () { 
            return this.edicao_atp_etq.tipo && this.edicao_atp_etq.tipo.js_opcoes && this.edicao_atp_etq.tipo.js_opcoes.length;
        },

        cassetes_selecionados: function () { 
            if ( !this.lista_cassetes ) { 
                return []; 
            }

            return this.lista_cassetes.filter(cassete => !cassete.fl_ativo);
        },

        opcoes_selecionadas: function () { 
            if ( !this.opcoes ) { 
                return []; 
            }

            return this.opcoes.filter(opcao => opcao.selec);
        },
    },

    watch: { 
        edicao_atp_etq: {
            handler (newval) { 
                if ( newval && newval.id_tipo_etiqueta_amostra ) { 
                    return; 
                }

                if ( newval && newval.tipo && newval.tipo.js_opcoes && newval.tipo.js_opcoes.length ) { 
                    this.opcoes = newval.tipo.js_opcoes.map( opcao => { 
                        return { 
                            nome: opcao.nome, 
                            selec: false, 
                            edit: false, 
                        };
                    });
                } else { 
                    this.opcoes = []; 
                }
            },
            deep: true,
        },
    },

    methods: {
        marcar_cassete_todos () { 
            let selec = this.lista_cassetes.find(cassete => !cassete.fl_ativo) ? true : false;

            this.lista_cassetes.forEach(cassete => { 
                cassete.fl_ativo = selec;
            });
        },

        refresh_lista () { 
            this.lista_nova.splice(this.edicao_atp_etq.in_quantidade); 

            for (let index = 0; index < this.edicao_atp_etq.in_quantidade; index++) {
                if ( this.lista_nova.length < index + 1 ) { 
                    this.lista_nova.push({ 
                        st_titulo: "", 
                    });
                } else { 
                    // já existe
                }
            }
        },

        abrir (atp = null) { 
            this.lista_cassetes = []; 
            this.lista_nova = []; 

            if ( !this.amostras ) { 
                this.$util.load(this, { 
                    service: 'atendimentos',
                    func: 'show',
                    parms: { 
                        id: atp.id_atendimento, 
                        amostras: true, 
                        coleta: false, 
                    },
                    loadTo: res => { 
                        this.loaded_amostras = res.amostras;
                        this.lista_cassetes = this.loaded_amostras.filter(amostra => amostra.id_tipo_etiqueta_amostra && amostra.st_titulo.toUpperCase().includes('CASSETE') && !amostra.id_amostra_repeticao);
                    }
                });
            } else { 
                this.lista_cassetes = _.cloneDeep(this.amostras).filter(amostra => amostra.id_tipo_etiqueta_amostra && amostra.st_titulo.toUpperCase().includes('CASSETE') && !amostra.id_amostra_repeticao);
            }

            this.atp = _.cloneDeep(atp);

            this.validate = false; 

            this.edicao_atp_etq = { 
                id_atendimento_procedimento: atp.id_atendimento_procedimento,
                id_tipo_etiqueta_amostra: null,
                tipo: "", 
                in_quantidade: 1,
                opcoes: [], 
            };

            $('#' + this.modal_name).modal('show');

        },

        fechar_modal () { 
            $('#' + this.modal_name).modal('hide');
        },

        salvar_gerar_etiqueta () { 

            if ( this.tem_opcoes ) { 
                if ( !this.cassetes_selecionados.length ) { 
                    this.$toast.add({ 
                        severity: 'error', 
                        summary: 'Gerar', 
                        detail: 'Selecione ao menos um cassete.', 
                        life: 5000 
                    });

                    return; 
                }
                
                if ( !this.opcoes.find(opcao => opcao.selec) ) { 
                    this.$toast.add({ 
                        severity: 'error', 
                        summary: 'Gerar', 
                        detail: 'Selecione ao menos uma opção.', 
                        life: 5000 
                    });

                    return; 
                }
            }

            this.edicao_atp_etq.id_tipo_etiqueta_amostra = this.edicao_atp_etq.tipo.id_tipo_etiqueta_amostra;

            this.$util.atualizar(this, { 
                service: 'amostras',
                func: 'gerar_tipo_etiquetas_amostra',
                dados: { 
                    ...this.edicao_atp_etq,
                    opcoes: this.opcoes ? this.opcoes.filter(opcao => opcao.selec).map(opcao => opcao.nome) : [],
                    origem_id_amostras: this.cassetes_selecionados.map(cassete => cassete.id_amostra),
                    titulos: this.lista_nova,
                    impressao_ao_gerar: this.impressao_ao_gerar,
                    servidor_impressao: this.servidor_impressao,
                },
                toast: true, 
                modal: this.modal_name,
                callback: () => { 
                    this.$emit('refresh');
                }
            });

        },

    },

    beforeMount () { 
        this.modal_name = 'gerarEtiquetaModal' + this.$util.uuidv4();
        this.servidor_impressao = this.$util.getCookie('lab_servidor_impressao');
    },

}
</script>
